// const baseUrl = "http://localhost:80";

// // プラン一覧取得
// export const getPlanList = `${baseUrl}/rtcc/api/getPlanList`;
// // エリア一覧取得
// export const getAreaList = `${baseUrl}/rtcc/api/getAreaList`;
// // 国情報一覧取得(エリアID指定)
// export const getCountryListByArea = `${baseUrl}/rtcc/api/getCountryListByArea`;
// // 都市情報一覧取得(国ID指定)
// export const getCityListByCountry = `${baseUrl}/rtcc/api/getCityListByCountry`;
// // 保存した検索条件取得
// export const getFavoriteCondition = `${baseUrl}/rtcc/api/getFavoriteCondition`;
// // 保存した検索条件削除
// export const deleteFavoriteCondition = `${baseUrl}/rtcc/api/deleteFavoriteCondition`;
// // 保存した検索条件登録
// export const setFavoriteCondition = `${baseUrl}/rtcc/api/setFavoriteCondition`;
// // ホテル予約
// export const makeHotelReservation = `${baseUrl}/rtcc/api/makeHotelReservation`;
// // パスポート情報取得
// export const getPassportInfo = `${baseUrl}/rtcc/api/getPassportInfo`;
// // パスポート情報登録
// export const setPassportInfo = `${baseUrl}/rtcc/api/setPassportInfo`;
// // 空港マスタ一覧取得
// export const getAirportList = `${baseUrl}/rtcc/api/getAirportList`;
// // フライト情報取得
// export const getFlightInfo = `${baseUrl}/rtcc/api/getFlightInfo`;
// // フライト情報登録
// export const setFlightInfo = `${baseUrl}/rtcc/api/setFlightInfo`;
// // 約款情報一覧取得
// export const getClauseList = `${baseUrl}/rtcc/api/getClauseList`;
// // 予約確認
// export const confirmHotelReservation = `${baseUrl}/rtcc/api/confirmHotelReservation`;
// // 予約キャンセル
// export const cancelHotelReservation = `${baseUrl}/rtcc/api/cancelHotelReservation`;
// // おすすめプラン一覧取得
// export const getRecommendPlanList = `${baseUrl}/rtcc/api/getRecommendPlanList`;
// // プロパティ一覧取得
// export const getPropertyList = `${baseUrl}/rtcc/api/getPropertyList`;
// // 一時予約データ設定
// export const setTempReserveInfo = `${baseUrl}/rtcc/api/setTempReserveInfo`;
// // 一時予約データ取得
// export const getTempReserveInfo = `${baseUrl}/rtcc/api/getTempReserveInfo`;
// //ホテル一覧取得
// export const getHotelList = `${baseUrl}/rtcc/api/getHotelList`;
// プラン一覧取得
export const getPlanList = `/rtcc/api/getPlanList`;
// エリア一覧取得
export const getAreaList = `/rtcc/api/getAreaList`;
// 国情報一覧取得(エリアID指定)
export const getCountryListByArea = `/rtcc/api/getCountryListByArea`;
// 都市情報一覧取得(国ID指定)
export const getCityListByCountry = `/rtcc/api/getCityListByCountry`;
// 保存した検索条件取得
export const getFavoriteCondition = `/rtcc/api/getFavoriteCondition`;
// 保存した検索条件削除
export const deleteFavoriteCondition = `/rtcc/api/deleteFavoriteCondition`;
// 保存した検索条件登録
export const setFavoriteCondition = `/rtcc/api/setFavoriteCondition`;
// ホテル予約
export const makeHotelReservation = `/rtcc/api/makeHotelReservation`;
// パスポート情報取得
export const getPassportInfo = `/rtcc/api/getPassportInfo`;
// パスポート情報登録
export const setPassportInfo = `/rtcc/api/setPassportInfo`;
// 空港マスタ一覧取得
export const getAirportList = `/rtcc/api/getAirportList`;
// フライト情報取得
export const getFlightInfo = `/rtcc/api/getFlightInfo`;
// フライト情報登録
export const setFlightInfo = `/rtcc/api/setFlightInfo`;
// 約款情報一覧取得
export const getClauseList = `/rtcc/api/getClauseList`;
// 予約確認
export const confirmHotelReservation = `/rtcc/api/confirmHotelReservation`;
// 予約キャンセル
export const cancelHotelReservation = `/rtcc/api/cancelHotelReservation`;
// おすすめプラン一覧取得
export const getRecommendPlanList = `/rtcc/api/getRecommendPlanList`;
// プロパティ一覧取得
export const getPropertyList = `/rtcc/api/getPropertyList`;
// 一時予約データ設定
export const setTempReserveInfo = `/rtcc/api/setTempReserveInfo`;
// 一時予約データ取得
export const getTempReserveInfo = `/rtcc/api/getTempReserveInfo`;
// ホテル一覧取得
export const getHotelList = `/rtcc/api/getHotelList`;